export const ERROR_MSG = 'เกิดข้อผิดพลาดขึ้น, กรุณาลองใหม่อีกครั้ง'
export const NOT_FOUND_MSG = 'ไม่พบไอเทมที่ค้นหา, กรุณาลองใหม่อีกครั้ง'
export const SUCCESS_MSG = 'สำเร็จ'